import { FlyerCategories } from '@/types/flyer';
import lampIcon from '@/assets/categories/school/lamp.svg';
import sportsIcon from '@/assets/categories/school/sports.svg';
import artsIcon from '@/assets/categories/school/arts.svg';
import graduationCapIcon from '@/assets/categories/school/graduation-cap.svg';
import healthIcon from '@/assets/categories/school/health.svg';
import familyIcon from '@/assets/categories/school/family.svg';
import eventIcon from '@/assets/categories/school/icon-event.svg';
import studentOrganization from '@/assets/categories/school/student-organization.svg';

export const schoolCategories: FlyerCategories = [
  {
    id: 'academics',
    title: 'Academics',
    icon: lampIcon,
  },
  {
    id: 'athletics',
    title: 'Athletics',
    icon: sportsIcon,
  },
  {
    id: 'arts',
    title: 'Arts',
    icon: artsIcon,
  },
  {
    id: 'college_and_career',
    title: 'College & Career',
    icon: graduationCapIcon,
  },
  {
    id: 'school_events',
    title: 'School Events',
    icon: eventIcon,
  },
  {
    id: 'health_and_safety',
    title: 'Health & Safety',
    icon: healthIcon,
  },
  {
    id: 'student_organization',
    title: 'Student Organization',
    icon: studentOrganization,
  },
  {
    id: 'family_resources',
    title: 'Family Resources',
    icon: familyIcon,
  },
];
